/**
 *Objeto que contiene los filtros de búsqueda que se manipulan en el componente Filtro
 */
const SEARCH_FILTERS = {
	// INPUT TEXT
	//--------------------------------------------------------
	sch: {
		paramKey: "sch",
		paramValue: "",
		active: false,
		displayType: "input-text",
		displayLabel: {
			default: "Buscar",
			translationId: "buscar",
		},
	},
	// CHECKBOX SELECTOR
	//--------------------------------------------------------
	tema: {
		paramKey: "tema",
		displayType: "multicheckbox",
		displayLabel: {
			default: "Materias",
			translationId: "materia",
		},
		items: [
			{
				paramValue: "Ciencias",
				active: false,
				displayLabel: {
					default: "Ciencias",
					translationId: "ciencias",
				},
			},
			{
				paramValue: "Historia y ensayo",
				active: false,
				displayLabel: {
					default: "Historia y ensayo",
					translationId: "historia-y-ensayo",
				},
			},
			{
				paramValue: "Letras y números",
				active: false,

				displayLabel: {
					default: "Letras y números",
					translationId: "letras-y-numeros",
				},
			},
			{
				paramValue: "Artes y manualidades",
				active: false,

				displayLabel: {
					default: "Artes y manualidades",
					translationId: "artes-y-manualidades",
				},
			},
			{
				paramValue: "Canción y poesía",
				active: false,

				displayLabel: {
					default: "Canción y poesía",
					translationId: "cancion-y-poesia",
				},
			},
			{
				paramValue: "Narrativa",
				active: false,

				displayLabel: {
					default: "Narrativa",
					translationId: "narrativa",
				},
			},
		],
	},
	nivel: {
		paramKey: "nivel",
		displayType: "multicheckbox",
		displayLabel: {
			default: "Nivel de lectura",
			translationId: "nivel-de-lectura",
		},
		items: [
			{
				paramValue: "Primeros lectores",
				active: false,

				displayLabel: {
					default: "Primeros lectores",
					translationId: "primeros-lectores",
				},
			},
			{
				paramValue: "Lectores intermedios",
				active: false,

				displayLabel: {
					default: "Lectores intermedios",
					translationId: "lectores-intermedios",
				},
			},
			{
				paramValue: "Lectores avanzados",
				active: false,

				displayLabel: {
					default: "Lectores avanzados",
					translationId: "lectores-avanzados",
				},
			},
		],
	},
	genero: {
		paramKey: "genero",
		displayType: "multicheckbox",
		displayLabel: {
			default: "Género",
			translationId: "genero",
		},
		items: [
			{
				paramValue: "Cómic",
				active: false,
				displayLabel: {
					default: "Cómic",
					translationId: "comic",
				},
			},
			{
				paramValue: "Libro álbum",
				active: false,
				displayLabel: {
					default: "Libro álbum",
					translationId: "libro-album",
				},
			},
			{
				paramValue: "Cuento ilustrado",
				active: false,
				displayLabel: {
					default: "Cuento ilustrado",
					translationId: "cuento-ilustrado",
				},
			},
			{
				paramValue: "Poesía",
				active: false,
				displayLabel: {
					default: "Poesía",
					translationId: "poesia",
				},
			},
			{
				paramValue: "Crónica y ensayo",
				active: false,
				displayLabel: {
					default: "Crónica y ensayo",
					translationId: "cronica-y-ensayo",
				},
			},
			{
				paramValue: "Interactivo",
				active: false,
				displayLabel: {
					default: "Interactivo",
					translationId: "interactivo",
				},
			},
			{
				paramValue: "Didáctico",
				active: false,
				displayLabel: {
					default: "Didáctico",
					translationId: "didactico",
				},
			},
			{
				paramValue: "Teatro",
				active: false,
				displayLabel: {
					default: "Teatro",
					translationId: "teatro",
				},
			},
			{
				paramValue: "Cuento",
				active: false,
				displayLabel: {
					default: "Cuento",
					translationId: "cuento",
				},
			},
			{
				paramValue: "Novela",
				active: false,
				displayLabel: {
					default: "Novela",
					translationId: "novela",
				},
			},
			{
				paramValue: "Informativo",
				active: false,
				displayLabel: {
					default: "Informativo",
					translationId: "informativo",
				},
			},
		],
	},
	edad: {
		paramKey: "edad",
		displayType: "multicheckbox",
		displayLabel: {
			default: "Edad",
			translationId: "edad",
		},
		items: [
			{
				paramValue: "3",
				active: false,
				displayLabel: {
					default: "Desde 3 años",
					translationId: "desde-3-anos",
				},
			},
			{
				paramValue: "5",
				active: false,
				displayLabel: {
					default: "Desde 5 años",
					translationId: "desde-5-anos",
				},
			},
			{
				paramValue: "7",
				active: false,
				displayLabel: {
					default: "Desde 7 años",
					translationId: "desde-7-anos",
				},
			},
			{
				paramValue: "9",
				active: false,
				displayLabel: {
					default: "Desde 9 años",
					translationId: "desde-9-anos",
				},
			},
			{
				paramValue: "11",
				active: false,
				displayLabel: {
					default: "Desde 11 años",
					translationId: "desde-11-anos",
				},
			},
			{
				paramValue: "13",
				active: false,
				displayLabel: {
					default: "Desde 13 años",
					translationId: "desde-13-anos",
				},
			},
			{
				paramValue: "15",
				active: false,
				displayLabel: {
					default: "Desde 15 años",
					translationId: "desde-15-anos",
				},
			},
		],
	},
	dificultadLectora: {
		paramKey: "dificultadLectora",
		displayType: "multicheckbox",
		displayLabel: {
			default: "Dificultad lectora",
			translationId: "dificultadLectora",
		},
		items: [
			{
				// paramKey: 'A-B-C',
				paramValue: "A;B;C",
				active: false,
				displayLabel: {
					default: "A-B-C",
					translationId: null,
				},
			},
			{
				// paramKey: 'D-E-F-G-H-I-J',
				paramValue: "D;E;F;G;H;I;J",
				active: false,
				displayLabel: {
					default: "D-E-F-G-H-I-J",
					translationId: null,
				},
			},
			{
				// paramKey: 'K-L-M',
				paramValue: "K;L;M",
				active: false,
				displayLabel: {
					default: "K-L-M",
					translationId: null,
				},
			},
			{
				// paramKey: 'N-O-P',
				paramValue: "N;O;P",
				active: false,
				displayLabel: {
					default: "N-O-P",
					translationId: null,
				},
			},
			{
				// paramKey: 'Q-R-S',
				paramValue: "Q;R;S",
				active: false,
				displayLabel: {
					default: "Q-R-S",
					translationId: null,
				},
			},
			{
				// paramKey: 'T-U-V',
				paramValue: "T;U;V",
				active: false,
				displayLabel: {
					default: "T-U-V",
					translationId: null,
				},
			},
			{
				// paramKey: 'W-X-Y-Z-Z+',
				paramValue: "W;X;Y;Z;Z+",
				active: false,
				displayLabel: {
					default: "W-X-Y-Z-Z+",
					translationId: null,
				},
			},
		],
	},
	// CHECKBOX
	//--------------------------------------------------------
	actividad: {
		paramKey: "actividad",
		paramValue: "1",
		active: false,
		displayType: "checkbox",
		displayLabel: {
			default: "Actividad",
			translationId: "actividad",
		},
	},
	bilingue: {
		paramKey: "bilingue",
		paramValue: "1",
		active: false,
		displayType: "checkbox",
		displayLabel: {
			default: "Libros bilingües",
			translationId: "bilingue",
		},
	},
	libroPremiado: {
		paramKey: "libroPremiado",
		paramValue: "1",
		active: false,
		displayType: "checkbox",
		displayLabel: {
			default: "Libro premiado",
			translationId: "libroPremiado",
		},
	},
	libroAccesible: {
		paramKey: "libroAccesible",
		paramValue: "1",
		active: false,
		displayType: "checkbox",
		displayLabel: {
			default: "Libro con lectura asistida",
			translationId: "libroAccesible",
		},
	},
	
	// ORDER 
	orderBy: {
		paramKey: "orderBy",
		paramValue: "title",
		active: false,
		displayType: 'sort-dropdown',
		displayLabel: {
			default: null,
			translationId: null,
		},
	},
	orderType: {
		paramKey: "orderType",
		paramValue: "ASC",
		active: false,
		displayType: 'sort-dropdown',
		displayLabel: {
			default: null,
			translationId: null,
		},
	},
	tag: {
		paramKey: "tag",
		items:null, // se ponen en tiempo de ejecucion desde los params.
		active: false,
		displayType: null,
		displayLabel: {
			default: null,
			translationId: null,
		},
	},
	
};

export default SEARCH_FILTERS;
